import type { FunctionComponent } from 'react';

import type { BlocklistResult } from '@ballerine/business-analysis-schemas';

import { ctw } from '@/common';
import { BadgeCheck } from '../components/svg/BadgeCheck';
import { BadgeCritical } from '../components/svg/BadgeCritical';

type BlocklistStatusBadgeProps = {
  blocklist?: BlocklistResult | null;
  /** `pill` = filled summary-field badge; `inline` = icon + plain text for section headers (Figma). */
  variant?: 'pill' | 'inline';
  className?: string;
};

export const BlocklistStatusBadge: FunctionComponent<BlocklistStatusBadgeProps> = ({
  blocklist,
  variant = 'pill',
  className,
}) => {
  if (!blocklist) {
    return null;
  }

  const isAlert = blocklist.status === 'alert';
  const label = isAlert ? 'Blocklisted' : 'Clear';

  if (variant === 'inline') {
    return (
      <div className={ctw('flex items-center gap-1.5', className)}>
        {isAlert ? <BadgeCritical variant="simple" /> : <BadgeCheck variant="simple" />}
        <span className="font-medium text-slate-900">{label}</span>
      </div>
    );
  }

  return (
    <div
      className={ctw(
        'w-fit rounded-lg px-2 py-1 font-semibold text-white',
        isAlert ? 'bg-red-500' : 'bg-green-500',
        className,
      )}
    >
      <div className="flex items-center gap-1">
        <div className="-mb-2">{isAlert ? <BadgeCritical /> : <BadgeCheck />}</div>
        <span>{label}</span>
      </div>
    </div>
  );
};
